import logoEmpresa from "../../assets/img/logo.png";
import "./Lanyard.css";

export default function Lanyard() {
  return (
    <div className="lanyard-wrapper">
      <div className="lanyard-content">
        <div className="lanyard-strap">
          <div className="strap-detail detail-one"></div>
          <div className="strap-detail detail-two"></div>
        </div>

        <div className="lanyard-connector"></div>
        <div className="lanyard-hook"></div>

        <div className="lanyard-card">
          <div className="lanyard-card-hole"></div>

          <div className="lanyard-logo-box">
            <img src={logoEmpresa} alt="Logo da empresa" />
          </div>
        </div>
      </div>
    </div>
  );
}
